export default __webpack_public_path__ + "media/images/fonts/fontawesome-webfont-db812d8a70a4e88e888744c1c9a27e89.woff2";